// extracted by mini-css-extract-plugin
export default {"button":"common-button_button__4I2mL","loading":"common-button_loading__2BzLo","label":"common-button_label__QvWDu","icon":"common-button_icon__BOZET"};